// Novidades da versão (flag `crm.sistema.novidades`): o que mudou em cada publicação
// deste ambiente, só o que é para o clube (`publico = 'clube'`, a RLS garante o resto).
// Paginado no servidor (IR-RX-007): "Ver mais antigas" aumenta o limite de 25 em 25.
// Doc: docs/funcionalidades/novidades-da-versao.md
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { qk } from '@pps/query-keys';
import { supabase } from '@/integrations/supabase/client';
import type { NovidadeDoClube } from '@/lib/novidades';

export const NOVIDADES_POR_PAGINA = 25;

export function useNovidades(limite: number, ativo: boolean) {
  return useQuery({
    queryKey: [...qk.plataforma.novidadesDoClube(), limite],
    enabled: ativo,
    staleTime: 5 * 60_000,
    placeholderData: keepPreviousData,
    queryFn: async (): Promise<{ itens: NovidadeDoClube[]; total: number }> => {
      const { data, error, count } = await supabase
        .from('plataforma_novidades')
        .select('chave, titulo, texto, publicada_em, versao, flag', { count: 'exact' })
        .eq('publico', 'clube')
        .in('app', ['crm', 'plataforma'])
        .order('publicada_em', { ascending: false })
        .order('chave', { ascending: true })
        .range(0, limite - 1);
      if (error) throw error;
      return { itens: (data ?? []) as NovidadeDoClube[], total: count ?? 0 };
    },
  });
}
